var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nostyle",attrs:{"href":_vm.object.url()}},[_c('div',{staticClass:"objectView"},[_c('h3',[_vm._v(_vm._s(_vm.object.name))]),_vm._v(" "),_c('ObjectImage',{attrs:{"object":_vm.object,"scaleUpTo":"80"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e2cd94","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObjectView.vue
// module id = 43
// module chunks = 0